export default __webpack_public_path__ + "static/media/main_loading_img.901e3c7b.gif";